import { Input } from '@shared/ui/kit';
import { Modal } from '@shared/ui/modal';
import { useEffect, useState } from 'react';
import styles from './EditInvitingManagerModal.module.scss';

interface EditInvitingManagerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  salesManager: string;
  invitingManager: string;
}

export const EditInvitingManagerModal = ({
  isOpen,
  onClose,
  onSave,
  salesManager,
  invitingManager,
}: EditInvitingManagerModalProps) => {
  const [draft, setDraft] = useState(invitingManager);

  useEffect(() => {
    if (!isOpen) return;
    setDraft(invitingManager);
  }, [isOpen, invitingManager]);

  const isEmpty = !draft.trim();
  const status = isEmpty ? 'error' : 'default';
  const inputMessage = isEmpty ? 'Обязательное поле' : undefined;

  const handleSave = () => {
    if (isEmpty) return;
    onSave(draft);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Редактировать менеджера"
      width={528}
      className={styles.modal}
      cancelButton={{
        text: 'Отмена',
        onClick: onClose,
        settings: { width: '106px', minWidth: '106px' },
      }}
      applyButton={{
        text: 'Сохранить',
        onClick: handleSave,
        isDisabled: isEmpty,
        settings: { width: '112px', minWidth: '112px' },
      }}
    >
      <div className={styles.content}>
        <Input value={salesManager} labelText="Менеджер по продажам" readonly settings={{ width: '100%' }} />

        <Input
          value={draft}
          changeFunction={setDraft}
          labelText="Приглашающий менеджер *"
          placeholder="Введите ФИО"
          status={status}
          inputMessage={inputMessage}
          settings={{ width: '100%' }}
        />
      </div>
    </Modal>
  );
};
